export default __webpack_public_path__ + "static/media/LightOn.8ec1f228.svg";